(function() {
    /* global turnstile */
    document.addEventListener('alpine:init', () => {
        Alpine.data('limeIntegration', () => ({
            activeTab: 0,
            activeSubTab: '',
            nextTab: 1,
            nextSubTab: '1_1',

            isOvernightStayShort: false,
            isOvernightStayLong: false,
            numberParticipant: '',
            numberGuestsSleeping: '',
            showErrorParticipant: false,
            showErrorOvernight: false,
            showErrorParticipantAdvanced: false,
            showErrorOvernightAdvanced: false,
            showErrorName: false,
            showErrorPhone: false,
            showErrorEmail: false,
            showErrorCompany: false,
            showErrorNameAdvanced: false,
            showErrorPhoneAdvanced: false,
            showErrorEmailAdvanced: false,
            showErrorCompanyAdvanced: false,
            loading: false,
            selectedArea: '',

            // Need this for some form stuff
            init() {

                // When `selectedArea` change, update hidden-input
                this.$watch('selectedArea', (value) => {
                    const hiddenInput = document.getElementById(
                        'selected-areas-list');
                    if (hiddenInput) {
                        hiddenInput.value = value.trim();
                    }
                });

                // Generate a new token for Cloudflare when we restart
                /*this.$watch('activeTab', (value) => {
                 if (value === 0 && typeof turnstile !== 'undefined') {
                 const turnstileDiv = document.querySelector(
                 '.cf-turnstile');

                 if (turnstileDiv) {
                 // Clear content first
                 turnstileDiv.innerHTML = '';

                 // Render a new widget
                 turnstile.render(turnstileDiv, {
                 sitekey: '0x4AAAAAABbkN0DwIZjEXoV0',
                 theme: 'light',
                 callback: 'onTurnstileSuccess',
                 });
                 }
                 }
                 });*/


            }, // end init function

            toggleOvernightStayShort(value) {
                this.isOvernightStayShort = value;
            },
            toggleOvernightStayLong(value) {
                this.isOvernightStayLong = value;
            },

            validateFields(selectors = []) {
                const requiredFields = selectors
                    .map(selector => document.querySelector(selector))
                    .filter(el => el && el.offsetParent !== null);

                let isValid = true;

                // Nollställ först
                this.showErrorParticipant = false;
                this.showErrorOvernight = false;
                this.showErrorParticipantAdvanced = false;
                this.showErrorOvernightAdvanced = false;
                this.showErrorName = false;
                this.showErrorPhone = false;
                this.showErrorEmail = false;
                this.showErrorCompany = false;
                this.showErrorNameAdvanced = false;
                this.showErrorPhoneAdvanced = false;
                this.showErrorEmailAdvanced = false;
                this.showErrorCompanyAdvanced = false;

                requiredFields.forEach(field => {
                    const valueMissing = !field.value ||
                        (field.type === 'number' && parseInt(field.value) <= 0);
                    const dataId = field.dataset.id;

                    // Validera nummerfält
                    if (field.type === 'number' && parseInt(field.value) <= 0) {
                        field.classList.add('border-red-600');
                        isValid = false;

                        // Sätt rätt flagga om värdet är mindre än eller lika med 0
                        if (dataId === 'participants') {
                            this.showErrorParticipant = true;
                        }

                        if (dataId === 'overnight-participants') {
                            this.showErrorOvernight = true;
                        }

                        if (dataId === 'participants-advanced') {
                            this.showErrorParticipantAdvanced = true;
                        }

                        if (dataId === 'overnight-participants-advanced') {
                            this.showErrorOvernightAdvanced = true;
                        }
                    } else if (
                        field.type === 'email' &&
                        !this.isValidEmail(field.value)
                    ) {
                        field.classList.add('border-red-600');
                        isValid = false;

                        // Sätt felmeddelande för ogiltig e-postadress
                        if (dataId === 'email') {
                            this.showErrorEmail = true;
                        }
                        if (dataId ===
                            'email-advanced') {
                            this.showErrorEmailAdvanced =
                                true;
                        }
                    }

                    if (valueMissing && !this.isValidEmail(field.value)) {
                        field.classList.add('border-red-600');
                        isValid = false;

                        // Sätt rätt flagga
                        if (dataId ===
                            'participants') {
                            this.showErrorParticipant = true;
                        }
                        if (dataId ===
                            'overnight-participants') {
                            this.showErrorOvernight =
                                true;
                        }
                        if (dataId ===
                            'participants-advanced') {
                            this.showErrorParticipantAdvanced =
                                true;
                        }
                        if (dataId ===
                            'overnight-participants-advanced') {
                            this.showErrorOvernightAdvanced =
                                true;
                        }
                        if (dataId === 'name') {
                            this.showErrorName = true;
                        }
                        if (dataId === 'phone') {
                            this.showErrorPhone = true;
                        }
                        if (dataId === 'email') {
                            this.showErrorEmail = true;
                        }
                        if (dataId === 'company') {
                            this.showErrorCompany = true;
                        }
                        if (dataId ===
                            'name-advanced') {
                            this.showErrorNameAdvanced = true;
                        }
                        if (dataId ===
                            'phone-advanced') {
                            this.showErrorPhoneAdvanced =
                                true;
                        }
                        if (dataId ===
                            'email-advanced') {
                            this.showErrorEmailAdvanced =
                                true;
                        }
                        if (dataId ===
                            'company-advanced') {
                            this.showErrorCompanyAdvanced =
                                true;
                        }
                    } else {
                        field.classList.remove('border-red-600');
                    }
                });

                return isValid;
            },

            isValidEmail(email) {
                const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                return emailPattern.test(email);
            },

            nextStepInitial() {
                this.activeTab = this.nextTab;
                this.activeSubTab = this.nextSubTab;

                track({
                    event: 'form_step',
                    step: this.activeTab === 1
                        ? 'simple_1'
                        : 'advanced_1',
                    direction: 'forward',
                });
            },

            nextStepSimple() {
                if (this.activeSubTab === '1_1') {
                    const fieldsToValidate = this.isOvernightStayShort
                        ? [
                            '[data-id=participants]',
                            '[data-id=overnight-participants]',
                        ]
                        : ['[data-id=participants]'];

                    if (this.validateFields(fieldsToValidate)) {
                        this.activeSubTab = '1_2';

                        track({
                            event: 'form_step',
                            step: 'simple_2',
                            direction: 'forward',
                        });
                    }
                } else if (this.activeSubTab === '1_2') {
                    this.handleFinalStep('simple');
                }
            },

            prevStepSimple() {
                if (this.activeSubTab === '1_2') {
                    this.activeSubTab = '1_1';

                    track({
                        event: 'form_step',
                        step: 'simple_1',
                        direction: 'backward',
                    });
                } else if (this.activeSubTab === '1_1') {
                    this.activeTab = 0;

                    track({
                        event: 'form_step',
                        step: 'initial',
                        direction: 'backward',
                    });
                }
            },

            nextStepAdvanced() {
                if (this.activeSubTab === '2_1') {
                    const fieldsToValidate = this.isOvernightStayLong
                        ? [
                            '[data-id=participants-advanced]',
                            '[data-id=overnight-participants-advanced]',
                        ]
                        : ['[data-id=participants-advanced]'];

                    if (this.validateFields(fieldsToValidate)) {
                        this.activeSubTab = '2_2';
                    }

                    track({
                        event: 'form_step',
                        step: 'advanced_2',
                        direction: 'forward',
                    });
                } else if (this.activeSubTab === '2_2') {
                    this.activeSubTab = '2_3';

                    track({
                        event: 'form_step',
                        step: 'advanced_3',
                        direction: 'forward',
                    });
                } else if (this.activeSubTab === '2_3') {
                    this.handleFinalStep('advanced');
                }
            },

            prevStepAdvanced() {
                if (this.activeSubTab === '2_3') {
                    this.activeSubTab = '2_2';

                    track({
                        event: 'form_step',
                        step: 'advanced_2',
                        direction: 'backward',
                    });
                } else if (this.activeSubTab === '2_2') {
                    this.activeSubTab = '2_1';

                    track({
                        event: 'form_step',
                        step: 'advanced_1',
                        direction: 'backward',
                    });
                } else if (this.activeSubTab === '2_1') {
                    this.activeTab = 0;

                    track({
                        event: 'form_step',
                        step: 'initial',
                        direction: 'backward',
                    });
                }
            },

            collectFormData(formId) {
                const formElement = document.querySelector(formId);
                if (formElement) {
                    return new FormData(formElement);
                }

                return null;
            },

            async handleFinalStep(type) {
                // const disabledButton = document.querySelector(
                //     '.final_step_button[disabled]');
                // if (disabledButton) {
                //     disabledButton.removeAttribute('disabled');
                // }

                this.loading = true; // DISABLE BUTTON

                let fieldsToValidate = [];
                let submitFunction = null;

                if (type === 'simple') {
                    fieldsToValidate = [
                        '[data-id=name]',
                        '[data-id=email]',
                        '[data-id=phone]',
                        '[data-id=company]',
                    ];

                    submitFunction = this.handleSimpleForm;
                } else if (type === 'advanced') {
                    fieldsToValidate = [
                        '[data-id=name-advanced]',
                        '[data-id=email-advanced]',
                        '[data-id=phone-advanced]',
                        '[data-id=company-advanced]',
                    ];

                    submitFunction = this.handleAdvancedForm;
                } else {
                    console.error('Okänd formtyp:', type);
                    return;
                }

                // if (this.validateFields(fieldsToValidate)) {
                //     const disabledButton = document.querySelector(
                //         '.final_step_button[disabled]');
                //     if (disabledButton) {
                //         disabledButton.removeAttribute('disabled');
                //     }

                if (!this.validateFields(fieldsToValidate)) {
                    this.loading = false; // Validation failed -> Re-enable button
                    return;
                }

                try {
                    const result = await submitFunction.call(this);
                    this.activeTab = result ? 3 : 4;

                    if (result) {
                        document.cookie =
                            'offer_request_bookmark_clicked=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
                        document.cookie =
                            'svm_bookmarks=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';

                        setTimeout(() => {
                            if (typeof refreshBookmarks === 'function') {
                                refreshBookmarks();
                            }

                            if (typeof updateBookmarkCount === 'function') {
                                updateBookmarkCount();
                            }

                            if (
                                typeof checkOfferRequestCookieAndUpdateUI ===
                                'function'
                            ) {
                                checkOfferRequestCookieAndUpdateUI();
                            }
                        }, 100); // maybe need higher value to clear cookies
                    }

                } catch (error) {
                    console.error('Fel vid inskick:', error);
                } finally {
                    this.loading = false; // ENABLE BUTTON?
                }
            },

            resetForm(formId) {
                const form = document.querySelector(formId);
                if (!form) {
                    return;
                }

                // Töm alla inputs, textareas och selects
                form.querySelectorAll('input, textarea, select')
                    .forEach(input => {
                        if (input.type === 'checkbox') {
                            input.checked = false;
                        } else {
                            input.value = '';
                        }
                    });

                // Nollställ alla felklasser
                form.querySelectorAll('.border-red-600').forEach(el => {
                    el.classList.remove('border-red-600');
                });
            },

            async handleSimpleForm() {

                const simpleFormData = this.collectFormData('#simpleForm');

                if (!simpleFormData) {
                    console.error('Kunde inte hitta formuläret #simpleForm');

                    return false;
                }

                // Lägg till selected-areas-list manuellt om det finns
                const selectedAreasField = document.querySelector(
                    '#selected-areas-list');
                if (selectedAreasField) {
                    simpleFormData.append(
                        'selected-areas-list',
                        selectedAreasField.value,
                    );
                }

                simpleFormData.append('action', 'lime_integration_simple');

                const selectedHotels = document.querySelector(
                    '[name="bookmarks_names"]');
                if (selectedHotels) {
                    simpleFormData.append(
                        'selected_hotels',
                        selectedHotels.value,
                    );
                }

                // Cloudflare Turnstile
                /*const turnstileToken = document.querySelector(
                 '[name="cf-turnstile-response"]');
                 if (!turnstileToken) {
                 console.error('Bekräfta att du inte är en robot.');

                 return false;
                 }

                 simpleFormData.append('turnstile_token', turnstileToken.value);*/

                try {
                    let response = await fetch(appAjax.ajax_url, {
                        method: 'POST',
                        body: simpleFormData,
                    });

                    if (!response.ok) {
                        throw new Error('Nätverksfel vid skickande');
                    }

                    const result = await response.json();

                    console.log('Svar från server:', result);

                    if (result.success === false) {
                        throw new Error('Formulärfel från servern');
                    }

                    track({
                        event: 'form_finish',
                        form: 'simple',
                    });

                    return !!result.success;
                } catch (error) {
                    console.error('Fel vid skickande:', error);

                    return false;
                }
            },

            async handleAdvancedForm() {
                const advancedFormData = this.collectFormData('#advancedForm');

                if (!advancedFormData) {
                    console.error('Kunde inte hitta formuläret #advancedForm');

                    return false;
                }

                // Lägg till selected-areas-list manuellt
                const selectedAreasField = document.querySelector(
                    '#selected-areas-list');
                if (selectedAreasField) {
                    advancedFormData.append(
                        'selected-areas-list',
                        selectedAreasField.value,
                    );
                }

                advancedFormData.append('action', 'lime_integration_advanced');

                const selectedHotels = document.querySelector(
                    '[name="bookmarks_names"]');
                if (selectedHotels) {
                    advancedFormData.append(
                        'selected_hotels',
                        selectedHotels.value,
                    );
                }

                // Cloudflare Turnstile
                /*const turnstileToken = document.querySelector(
                 '[name="cf-turnstile-response"]');
                 if (!turnstileToken) {
                 console.error('Bekräfta att du inte är en robot.');

                 return false;
                 }

                 advancedFormData.append(
                 'turnstile_token',
                 turnstileToken.value,
                 );*/

                try {
                    let response = await fetch(appAjax.ajax_url, {
                        method: 'POST',
                        body: advancedFormData,
                    });

                    if (!response.ok) {
                        throw new Error('Nätverksfel vid skickande');
                    }

                    let result = await response.json();

                    console.log('Svar från server:', result);

                    if (result.success === false) {
                        throw new Error('Formulärfel från servern');
                    }

                    track({
                        event: 'form_finish',
                        form: 'advanced',
                    });

                    return !!result.success;
                } catch (error) {
                    console.error('Fel vid skickande:', error);

                    return false;
                }
            },
        }));
    });
}());

//# sourceMappingURL=lime-integration.js.map
